var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-detail flex"},[_c('icon',{class:_vm.titleDescription,attrs:{"name":_vm.icon}}),_c('div',{staticClass:"text-white-100 cursor-text"},[_c('tool-tip',{attrs:{"text":_vm.value,"hideCopy":true,"trim":_vm.data[_vm.routerName].hideTrim}}),_c('span',{staticClass:"capitalize"},[_vm._v(" "+_vm._s(_vm.titleDescription))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }